module.exports = __webpack_public_path__ + "static/media/Logo-QL-Blue.7c912dc2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo/Logo-QL-Blue.svg
// module id = 516
// module chunks = 0